import { render } from "./ForceUpdateModal.vue?vue&type=template&id=3cc59960&scoped=true"
import script from "./ForceUpdateModal.vue?vue&type=script&lang=js"
export * from "./ForceUpdateModal.vue?vue&type=script&lang=js"

import "./ForceUpdateModal.vue?vue&type=style&index=0&id=3cc59960&scoped=true&lang=css"
import "./ForceUpdateModal.vue?vue&type=style&index=1&id=3cc59960&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc59960"]])

export default __exports__